var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4861,
    cy: 44,
    r: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3195 32.3333H22.6528C19.4328 32.3333 16.8195 34.935 16.8195 38.1433V45.12V46.2867C16.8195 49.495 19.4328 52.0967 22.6528 52.0967H24.4028C24.7178 52.0967 25.1378 52.3067 25.3361 52.5633L27.0861 54.885C27.8561 55.9117 29.1161 55.9117 29.8861 54.885L31.6361 52.5633C31.8578 52.2717 32.2078 52.0967 32.5695 52.0967H34.3195C37.5395 52.0967 40.1528 49.495 40.1528 46.2867V38.1433C40.1528 34.935 37.5395 32.3333 34.3195 32.3333ZM29.6528 46.0417H22.6528C22.1745 46.0417 21.7778 45.645 21.7778 45.1667C21.7778 44.6883 22.1745 44.2917 22.6528 44.2917H29.6528C30.1311 44.2917 30.5278 44.6883 30.5278 45.1667C30.5278 45.645 30.1311 46.0417 29.6528 46.0417ZM34.3195 40.2083H22.6528C22.1745 40.2083 21.7778 39.8117 21.7778 39.3333C21.7778 38.855 22.1745 38.4583 22.6528 38.4583H34.3195C34.7978 38.4583 35.1945 38.855 35.1945 39.3333C35.1945 39.8117 34.7978 40.2083 34.3195 40.2083Z",
    fill: "#6374FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5725 5.78625L52.4036 17.4717",
    stroke: "#6374FA",
    strokeWidth: 3.125,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5139 25.3485L56.4898 27.2067",
    stroke: "#6374FA",
    strokeWidth: 3.125,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.486 2L40.4861 12.3289",
    stroke: "#6374FA",
    strokeWidth: 3.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChat);
export default __webpack_public_path__ + "static/media/AiChat.1d0fb90504789681a000436bb25e2168.svg";
export { ForwardRef as ReactComponent };